// extracted by mini-css-extract-plugin
export var externalLink = "_bb-0";
export var internalLinkLabel = "_bb-1";